import { render, staticRenderFns } from "./security_psw.vue?vue&type=template&id=47ea4d6e"
import script from "./security_psw.vue?vue&type=script&lang=js"
export * from "./security_psw.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports